module.exports = __webpack_public_path__ + "static/media/1-4-mobile.f922ba2d.webp";